export const COLOR_THEMES = [
  'current',
  'Primary',
  'Secondary',
  'Warning',
  'Error',
  'Info',
  'Light'
];
